/** @format */

"use client"; //this is a client side component

import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import axios from "axios";
import ApiInstance from "./instance";
import { SortFunctionForAnswers, SortFunctionForTabs } from "../../Utils";

const initialState = {
    isLoading: false,
    tabs: [],
    answers: {},
    taxTabData: [],
    bookkeepingTabData: [],
    tabsToDisplay: [],
    currentTab: 0,
    currentQuestion: 0,
};

export const tabsSlice = createSlice({
    name: "tabs",
    initialState,
    reducers: {
        addTabsData: (state, action) => {
            const { tabs } = state; // Extract the existing tabs
            const tabIndex = tabs?.findIndex((el) => el?.tab_id === action.payload?.tab_id); // Find the tab index

            // Create a shallow copy of tabs
            let updatedTabs = [...tabs];

            if (tabIndex !== -1) {
                // Tab exists, handle updating questions
                const tab = { ...updatedTabs[tabIndex] }; // Shallow copy of the specific tab
                const questions = tab.questions ? [...tab.questions] : []; // Shallow copy of the questions array
                const questionIndex = questions.findIndex((el) => el?.question_id === action.payload?.question_id);

                if (questionIndex !== -1) {
                    // Question exists, update the answer
                    questions[questionIndex] = {
                        question_id: action.payload?.question_id,
                        answer: action.payload?.answer,
                    };
                } else {
                    // Question doesn't exist, add a new one
                    questions.push({
                        question_id: action.payload?.question_id,
                        answer: action.payload?.answer,
                    });
                }

                // Update the tab with the new questions array
                updatedTabs[tabIndex] = { ...tab, questions };
            } else {
                // Tab doesn't exist, add a new tab with the question
                updatedTabs = [
                    ...updatedTabs,
                    {
                        tab_id: action.payload?.tab_id,
                        questions: [
                            {
                                question_id: action.payload?.question_id,
                                answer: action.payload?.answer,
                            },
                        ],
                    },
                ];
            }
            console.log(updatedTabs, "updatedTabs---updatedTabs----in add")
            // Assign the updated tabs to the state
            state.tabs = SortFunctionForAnswers(updatedTabs);
        },
        deleteTabQuestion: (state, action) => {
            const { tabs } = state; // Extract the existing tabs
            const tabIndex = tabs?.findIndex((el) => el?.tab_id === action.payload?.tab_id); // Find the tab index
            console.log(action.payload, "payload")
            if (tabIndex !== -1) {
                // Tab exists, proceed to delete the question
                const tab = { ...tabs[tabIndex] }; // Shallow copy of the specific tab
                const questions = tab.questions ? [...tab.questions] : []; // Shallow copy of the questions array

                // Filter out the question with the specified question_id
                const updatedQuestions = questions.filter(
                    (el) => el?.question_id !== action.payload?.question_id
                );

                // Update the tab with the new questions array
                const updatedTab = { ...tab, questions: updatedQuestions };

                // Create a shallow copy of tabs with the updated tab
                const updatedTabs = [...tabs];
                updatedTabs[tabIndex] = updatedTab;
                console.log(updatedTabs, "updatedTabs---updatedTabs in deleted")
                // Assign the updated tabs to the state
                state.tabs = SortFunctionForAnswers(updatedTabs);
            }
        },
        resetTabsData: (state, action) => {
            state.tabs = SortFunctionForAnswers(action.payload)
        },

        setAnswers: (state, action) => {
            state.answers = { ...state.answers, ...action.payload }
        },
        removeAnswers: (state, action) => {
            state.answers = {}
        },
        setTabsToDisplay: (state, action) => {
            console.log(action, "payload in tabs to display")
            state.tabsToDisplay = SortFunctionForTabs(action.payload)
        },

        setCurrentTab: (state, action) => {
            state.currentTab = action.payload;
        },
        setCurrentQuestion: (state, action) => {
            state.currentQuestion = action.payload;
        },
        removeTabsData: (state, action) => {
            const newTabs = state.tabs?.filter((tab, index) => tab?.tab_id !== action.payload)
            state.tabs = SortFunctionForAnswers(newTabs)
        },


    },

});

export const { setAnswers, deleteTabQuestion, removeAnswers, addTabsData, setCurrentTab, setCurrentQuestion, setTabsToDisplay, removeTabsData, resetTabsData } = tabsSlice.actions;


export default tabsSlice.reducer;
